import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { FilterMenuBody } from "@/estimating/components/HeaderFilterMenu";

/** Connected filter pills in the Segmented rail style. pills: [{ key, label, options, value, onChange, multi, separator }].
 *  Empty value shows the bare label ("AM"); a pick shows "AM: BJ" / "Status (2)". */
// Action pill (no menu): p.onClick + p.active — e.g. Accounts "Unassigned" jumps to that section.
const ActionPill = ({ p }) => (
  <button type="button" onClick={p.onClick} data-testid={`pill-${p.key}`} data-active={p.active ? "1" : "0"}
          className={`inline-flex items-center whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
            p.active ? "bg-[#007BFF]/10 font-semibold text-[#007BFF] dark:bg-blue-950/50 dark:text-blue-300" : "text-slate-500 hover:text-slate-800"}`}>
    {p.label}
  </button>
);

export const Pill = ({ p }) => {
  const [open, setOpen] = useState(false);
  if (p.onClick) return <ActionPill p={p} />;
  const sep = p.separator || "|";
  const picks = p.value ? String(p.value).split(sep) : [];
  const one = picks.length === 1 ? String((p.options || []).find((o) => o.value === picks[0])?.label ?? picks[0]).split(" · ")[0] : "";
  const text = picks.length === 1 ? (p.bare ? one : `${p.label}: ${one}`) : p.label;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`pill-${p.key}`} data-active={picks.length ? "1" : "0"}
                className={`inline-flex max-w-[12rem] items-center gap-1 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                  picks.length ? "bg-[#007BFF]/10 font-semibold text-[#007BFF] dark:bg-blue-950/50 dark:text-blue-300" : "text-slate-500 hover:text-slate-800"}`}>
          <span className="truncate">{text}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-56 p-0" data-testid={`pill-menu-${p.key}`}>
        <FilterMenuBody options={p.options} value={p.value} onChange={p.onChange} testid={`pill-${p.key}`}
                        multi={p.multi} separator={sep} close={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
};

export default function FilterPills({ pills, testId }) {
  return (
    <div className="inline-flex max-w-full flex-wrap items-center gap-1 rounded-2xl bg-slate-100 p-1" data-testid={testId}>
      {pills.map((p) => <Pill key={p.key} p={p} />)}
    </div>
  );
}
